/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerDemographicsEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: CustomerDemographicsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { CustomerDemographicsData, CustomerDemographicsService }  from './CustomerDemographics.service';



@Component({
  template: require('./CustomerDemographicsEdit.component.html'),
  providers: [CustomerDemographicsService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomerDemographicsEditComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objCustomerDemographics: CustomerDemographicsData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private CustomerDemographicsService: CustomerDemographicsService

	) {
		// this.id = parseInt(params.get('id'));
		this.objCustomerDemographics = new CustomerDemographicsData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.CustomerDemographicsService.getByID(+params['id']))
		.switchMap((params: Params) => this.CustomerDemographicsService.getByID(params['id']))
		.subscribe((item: CustomerDemographicsData) => this.objCustomerDemographics = item);
		this.getLookups();
	}

	updateCustomerDemographics() {
		this.CustomerDemographicsService.updateCustomerDemographicsData(this.objCustomerDemographics)
			.subscribe(record => this.router.navigate(['/CustomerDemographics']),
				error =>  this.errorMessage = 'There was an error while updating record. Error: ' + <any>error,
				() => { 
					this.toastr.success('CustomerDemographics record updated successfully...', 'Edit CustomerDemographics');
					console.log('CustomerDemographics record updated successfully...'); 
				}
			);
	}
  
	deleteCustomerDemographics(id: string) {
		if (window.confirm('Are you sure you want to delete this CustomerDemographics?') == true) 
		{
			this.CustomerDemographicsService.deleteCustomerDemographics(this.objCustomerDemographics.CustomerTypeID.toString())
			.subscribe(record => this.router.navigate(['/CustomerDemographics']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('CustomerDemographics record deleted successfully...', 'Delete CustomerDemographics');
					console.log('CustomerDemographics record deleted successfully...'); 
				}
			);
		}
	}

	gotoCustomerDemographics() {
		let Id = this.objCustomerDemographics ? this.objCustomerDemographics.CustomerTypeID : null;
		this.router.navigate(['/CustomerDemographics']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerDemographics/CustomerDemographicsEdit.component.ts